module.exports = __webpack_public_path__ + "img/people1.d02fa9a2.png";